import { ref } from 'vue'

import silenceSound from '@shared/assets/sounds/silence.mp3'

/** @description
 * According by safari documentation, audio can be played only after user interaction (not directly from audio object) https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/Using_HTML5_Audio_Video/Device-SpecificConsiderations/Device-SpecificConsiderations.html
 *
 * So need to initialize audio on first user click on the document, that will allow to play audio in future
 * */

export const useInitializeAudio = () => {
  const count = ref(0)

  const initializeAudio = () => {
    document.addEventListener('click', () => {
      if (count.value > 0) {
        return
      }

      new Audio(silenceSound).play()
      count.value++
    })
  }

  return {
    count,
    initializeAudio,
  }
}
